import { useParametrosHorasExtrasContext } from 'Context/ParametrosHorasExtrasContext';
import Cargando from 'components/Varios/Cargando';
import YearDatePicker from 'components/Varios/DatePicker/YearDatePicker';
import React, { useMemo, useState } from 'react'
import { Card, CardBody, CardTitle, CardFooter, Row, Col, Button } from "reactstrap"
import { DetalleRegimenLaboralHEDTO } from './TypesPlanificacionHE';
import { useHistory } from 'react-router-dom';
import NumberFormat from 'react-number-format';

type PropsCardRegimenHE = {
    anio: number,
    nombreMes: string,
    numeroMes: number,
    puedeRealizarAccion: boolean
    regimenLaboralPlan: DetalleRegimenLaboralHEDTO | null;
    index: number;
}



export default function CardRegimenHEInicio(props: PropsCardRegimenHE) {

    const history = useHistory();
    let TITULO_CARD = props.nombreMes;

    const { regimenLaboralPlan } = props

    const color = getColor(props.index);  // Función para obtener el color basado en el índice

    // Función para seleccionar un color
    function getColor(index: number) {
        const colors = ['#00C77C', '#FF9597', '#F0915E', '#5059C3', '#D6A700', '#89BD00', '#0359C3', '#03C2C3', '#CC74BA'];
        return colors[index % colors.length];  // Usa el módulo para rotar a través de los colores
    }

    const buttonLabel = props.puedeRealizarAccion ? "INGRESAR PLANIFICACIÓN" : "VER PLANIFICACIÓN";

    const handleButtonClick = () => {
        const anio = props.anio;
        const numeroMes = props.numeroMes;
        const puedeRealizarAccion = props.puedeRealizarAccion;
        //history.push(`/directivo/planificacionHorasExtrasMensual?anio=${anio}&numeroMes=${numeroMes}&puedeRealizarAccion=${puedeRealizarAccion}`);
        history.push({
            pathname: '/directivo/planificacionHorasExtrasMensual',
            state: { anio, numeroMes, puedeRealizarAccion }
        });
    };

    return (
        <Card className="same-height-card">
            <CardTitle className="cardHeaderRegimenPlanificacion" style={{ backgroundColor: color }}  >
                {TITULO_CARD}

            </CardTitle>

            <CardBody>
                <Row>
                    <Col xl={12}>
                        <div className='groupInfoRegimen'>
                            <p className='labelInfoRegimenBlue'> PRESUPUESTO PROYECTADO: </p>
                            <p className='valueInfoRegimenBlue'>
                                {regimenLaboralPlan && <NumberFormat value={regimenLaboralPlan.presupuestoProyectado} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />}
                            </p>

                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xl={12}>
                        <div className='groupInfoRegimen'>
                            <p className='labelInfoRegimenGray'> PRESUPUESTO ASIGNADO: </p>
                            <p className='valueInfoRegimen'>
                                {
                                    !regimenLaboralPlan && <div> Presupuesto No Asignado</div>
                                }
                                {
                                    regimenLaboralPlan && <NumberFormat value={regimenLaboralPlan.presupuestoAsignado} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
                                }

                            </p>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xl={12}>
                        <div className='groupInfoRegimen'>
                            <p className='labelInfoRegimenGray'> REFORMA PRESUPUESTARIA <span className='spanLabelInfoRegimen'>(MODIFICACIONES):</span></p>
                            <p className='valueInfoRegimen'>


                                {regimenLaboralPlan && <NumberFormat value={regimenLaboralPlan.reformaPresupuestaria} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />}

                            </p>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xl={12}>
                        <div className='groupInfoRegimen'>
                            <p className='labelInfoRegimenBlack'> PRESUPUESTO CODIFICADO:</p>
                            <p className='valueInfoRegimen'>
                                {regimenLaboralPlan && <NumberFormat value={regimenLaboralPlan.presupuestoCodificado} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />}

                            </p>
                        </div>
                    </Col>
                </Row>
                <Row >
                    <Col xl={12}>
                        <div className='groupInfoRegimen'>
                            <p className='labelInfoRegimenGray'> PRESUPUESTO DEVENGADO:</p>
                            <p className='valueInfoRegimen'>
                                {/* {regimenLaboralPlan && <NumberFormat value={regimenLaboralPlan.devengadoPagado + regimenLaboralPlan.devengadoNoPagado} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
                                } */}
                                {regimenLaboralPlan && <NumberFormat value={regimenLaboralPlan.devengadoPagado} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
                                }
                            </p>
                        </div>
                    </Col>
                </Row>
                
                <Row >
                    <Col xl={12}>
                        <div className='groupInfoRegimen'>
                            <p className='labelInfoRegimenGray'> PRESUPUESTO DEVENGADO Y NO PAGADO:</p>
                            <p className='valueInfoRegimen'>
                                {/* {regimenLaboralPlan && <NumberFormat value={regimenLaboralPlan.devengadoPagado + regimenLaboralPlan.devengadoNoPagado} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
                                } */}
                                {regimenLaboralPlan && <NumberFormat value={regimenLaboralPlan.devengadoNoPagado} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
                                }
                            </p>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col xl={12}>
                        <div className='groupInfoRegimen'>
                            <p className='labelInfoRegimenBlack'> PRESUPUESTO POR DEVENGAR:</p>
                            <p className='valueInfoRegimen'>
                                {regimenLaboralPlan && <NumberFormat value={regimenLaboralPlan.presupuestoDevengar} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
                                }
                            </p>
                        </div>
                    </Col>
                </Row>
                <Row >
                    <Col xl={12}>
                        <div className='groupInfoRegimen'>
                            <p className='labelInfoRegimenGray'> PRESUPUESTO PLANIFICADO:    </p>
                            <p className='valueInfoRegimen'>
                                {regimenLaboralPlan && <NumberFormat value={regimenLaboralPlan.planificadoActual} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
                                }
                            </p>
                        </div>
                    </Col>
                </Row>
                <Row >
                    <Col xl={12}>
                        <div className='groupInfoRegimen'>
                            <p className='labelInfoRegimenGray'> PRESUPUESTO DEVENGADO MENSUAL:    </p>
                            <p className='valueInfoRegimen'>
                                {regimenLaboralPlan && <NumberFormat value={regimenLaboralPlan.presupuesotDevengadoMensual} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
                                }
                            </p>
                        </div>
                    </Col>
                </Row>
                <Row >
                    <Col xl={12}>
                        <div className='groupInfoRegimen'>
                            <p className='labelInfoRegimenGray'> PRESUPUESTO DEVENGADO RETROACTIVIDAD:    </p>
                            <p className='valueInfoRegimen'>
                                {regimenLaboralPlan && <NumberFormat value={regimenLaboralPlan.presupuestoDevengadoAdicional} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
                                }
                            </p>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col xl={12}>
                        <div className='groupButtonRegimen'>
                            <Button title={`${buttonLabel} - ${props.nombreMes}`} className="btnEspolPrimary" onClick={handleButtonClick}> {buttonLabel} </Button>
                        </div>
                    </Col>
                </Row>

            </CardBody>


        </Card>
    )


}